export default "__VITE_ASSET___2WFWA38__"